// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"9e9db580","246":"477208f0","306":"cf69e37b","397":"0e3d683f","472":"19c2497b","681":"bbf0e713","841":"a9e12888","922":"4686481f","970":"71228206"}[chunkId] + ".chunk.js";
};